import { render, staticRenderFns } from "./claimPush.vue?vue&type=template&id=717b5062&scoped=true&"
import script from "./claimPush.vue?vue&type=script&lang=js&"
export * from "./claimPush.vue?vue&type=script&lang=js&"
import style0 from "./claimPush.vue?vue&type=style&index=0&id=717b5062&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "717b5062",
  null
  
)

export default component.exports